import React from 'react';

export const CitationDisplay = ({ citations, apiBaseUrl }) => {
  if (!citations || citations.length === 0) return null;

  const handleDocumentClick = async (citation) => {
    try {
      if (!apiBaseUrl) {
        console.error('[CitationDisplay] No API base URL provided');
        return;
      }

      console.log('[CitationDisplay] 📄 Attempting to open PDF:', citation.filename);
      
      // Build PDF URL
      const pdfUrl = `${apiBaseUrl}/api/document/pdf/${encodeURIComponent(citation.filename)}`;
      console.log('[CitationDisplay] 📥 Fetching PDF from:', pdfUrl);
      
      const response = await fetch(pdfUrl, {
        headers: {
          'X-API-Key': process.env.REACT_APP_API_KEY || 'dev-api-key-12345'
        }
      });

      console.log('[CitationDisplay] PDF fetch response:', {
        status: response.status,
        statusText: response.statusText,
        contentType: response.headers.get('content-type')
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      // Create blob from PDF data
      const pdfBlob = await response.blob();
      console.log('[CitationDisplay] 📄 PDF blob created, size:', pdfBlob.size, 'bytes');
      
      // Create blob URL and open in new tab
      const blobUrl = URL.createObjectURL(pdfBlob);
      console.log('[CitationDisplay] 🔗 Opening PDF blob URL:', blobUrl);
      
      const newWindow = window.open(blobUrl, '_blank', 'noopener,noreferrer');
      
      // Clean up blob URL after a delay to allow browser to load it
      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
        console.log('[CitationDisplay] 🧹 Cleaned up blob URL');
      }, 10000);
      
      if (!newWindow) {
        console.warn('[CitationDisplay] ⚠️ Popup blocked. Trying alternative approach...');
        // Fallback: create download link
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = citation.filename;
        link.click();
      }

    } catch (error) {
      console.error('[CitationDisplay] ❌ Error loading PDF:', error);
      
      // Show user-friendly error message
      const errorMessage = error instanceof Error ? error.message : 'Unknown error';
      alert(`No se pudo abrir el PDF: ${errorMessage}\n\nPor favor verifica:\n- El documento existe en el servidor\n- La API key es válida\n- El servidor está funcionando`);
    }
  };

  return (
    <div className="mt-3 pt-2 border-t border-gray-100">
      <div className="text-xs text-gray-500 mb-2">Fuentes:</div>
      <div className="space-y-1">
        {citations.map((citation, index) => (
          <div key={index} className="flex items-center space-x-2 text-xs">
            <button
              onClick={() => handleDocumentClick(citation)}
              className="flex items-center space-x-1 text-blue-600 hover:text-blue-800 transition-colors"
              title="Abrir PDF"
            >
              <svg className="w-3 h-3 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
              </svg>
              <span className="truncate max-w-xs">{citation.filename}</span>
            </button>
            <span className="text-gray-400">p.{citation.pageNumber}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
